import React from 'react';
import styled from 'styled-components';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { TextInlineSkin } from '@origin-digital/style-guide';
import { StepIconSvgs } from './icons';

const SvgImageCurrent = styled(TextInlineSkin)`
  width: 100%;
  height: 100%;
  margin-left: -14px;
`;

const SvgImageFuture = styled(TextInlineSkin)`
  width: 100%;
  height: 100%;
`;

const OriginStepIconVertical = (props: StepIconProps) => {
  return props.icon === 1 ? (
    <SvgImageCurrent
      color="green"
      dangerouslySetInnerHTML={{
        __html: StepIconSvgs.currentStepSvg
      }}
    />
  ) : (
    <SvgImageFuture
      color="green"
      dangerouslySetInnerHTML={{
        __html: StepIconSvgs.futureStepSvg
      }}
    />
  );
};

export default OriginStepIconVertical;
